import { createFileRoute } from "@tanstack/react-router";

// Route metadata only. Component lives in `index.lazy.tsx`.
export const Route = createFileRoute("/admin/")({});
